import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Result, ResultOfT } from '../models/response/result';
import { UserResponseModel, PasswordExpiry } from '../models/response/user-response-model';
import { WebStorageService } from './web-storage.service';
import { TimeZoneAvailableResponseModel } from '../models/response/time-zone-available-response-model';
import { AuthenticationRequest } from '../models/request/authentication-request-model';
import { UserAuthResponseModelMain } from '../models/response/access-token-response-model';

@Injectable({
  providedIn: 'root'
})
export class SharedUserService extends BaseService {

  constructor(httpClinet: HttpClient, webStorageService: WebStorageService) {
    super(httpClinet, webStorageService);
  }

  // Note: The `btoa` function is used to encode the string in Base64 format.
  // Ensure that the input to `btoa` is a valid string, as it will throw an error if the input is not a valid string.
  forgotPassword(email: PasswordExpiry) {
    // Encode username as Base64 strings
    email.appUserEmail = btoa(email.appUserEmail || '');
    return this.post<Result>('Users/ForgotPassword/', email);
  }

  setPassword(userResponseModel: UserResponseModel) {
    // Encode password as Base64 strings
    const userresponse: UserResponseModel = {
      ...userResponseModel,
      appUserpassword: btoa(userResponseModel.appUserpassword || '')
    };
    return this.post<Result>('Users/SetPassword/', userresponse);
  }

  changePassword(userResponseModel: UserResponseModel) {
    const userresponse: UserResponseModel = {
      ...userResponseModel,
      appUserEmail: btoa(userResponseModel.appUserEmail || ''),
      appUserpassword: btoa(userResponseModel.appUserpassword || ''),
      appUserOldPassword: btoa(userResponseModel.appUserOldPassword || '')
    };
    return this.post<Result>('Users/ChangePassword/', userresponse);
  }

  GetTimeZoneListAsync() {
    return this.get<ResultOfT<TimeZoneAvailableResponseModel[]>>('Users/GetTimeZoneAsync');
  }

  killActiveSessionAndLogin(requestModel: AuthenticationRequest) {
    const userresponse: AuthenticationRequest = {
      ...requestModel,
      userName: btoa(requestModel.userName || ''),
      password: btoa(requestModel.password || '')
    };
    return this.post<ResultOfT<UserAuthResponseModelMain>>('Users/sessions/kill', userresponse);
  }

  IsPasswordExpired(email: PasswordExpiry) {
    // Encode username as Base64 strings
    email.appUserEmail = btoa(email.appUserEmail || '');
    return this.post<ResultOfT<number>>('Users/IsPasswordExpired/', email);
  }
}